<template>
    <PersonalAccountSearchForm
        v-model:contract-num="searchData.contractNum"
        v-model:start-date="searchData.start_date"
        v-model:end-date="searchData.end_date"
        date-label="Период обращения"
        @change="onChangeContractNum"
        @change-start-date="onChangeStartDate"
        @change-end-date="onChangeEndDate"
        @search="searchPayments"
    />
    <a-divider />
    <div class="personal_account_info">
        <div class="personal_account_info_left">
            <p>Всего обращении: <span>{{ pagination.total }}</span></p>
        </div>
        <div class="personal_account_info_right">
            <a-button @click="requestExcuse">
                Заявить о страховом событии
            </a-button>
            <a-button @click="exportContracts">
                <img src="../../assets/images/downloadFile.svg" alt="">
                Выгрузить данные раздела
            </a-button>
            <a-button @click="getAllReports">
                <img src="../../assets/images/downloadFile.svg" alt="">
                Общая выгрузка данных (все разделы)
            </a-button>
        </div>
    </div>
    <a-divider />
    <div class="personal_account_table">
        <a-table :columns="appealsScope === 'my' ? selfColumns : paymentColumns" :row-key="record => record.id"
            :data-source="road_accidents" :loading="isLoadingPaymentList" :scroll="{ x: '1500' }"
            :pagination="pagination" @change="onChangePagination" :custom-row="appealsScope === 'my' ? customRow : null"
            :class="{ 'table_clickable': appealsScope === 'my' }">
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'product'">
                    <div class="product_name_col">
                        <div class="product_name_line"></div>
                        <p>
                            {{ record.product }}
                        </p>
                    </div>

                </template>
                <template v-else-if="column.dataIndex === 'payment_sum'">
                    <p>
                        {{ record.payment_sum ? `${record.payment_sum}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '' }}
                    </p>
                </template>
                <template v-else-if="column.dataIndex === 'action'">
                    <button class="open_btn" @click="openContractModal(record)">
                        Открыть
                    </button>
                </template>

            </template>
        </a-table>
    </div>
    <ContractPaymentModal :openedContract="openedContract" :open="isOpenContractModal"
        @close="isOpenContractModal = !isOpenContractModal" />

    <a-modal :open="isModalInfo" :footer="null" @cancel="onCancel" :title="null" width="560px">
        <a-spin :spinning="isLoadingModal" style="min-height: 120px">
            <div v-if="selectedRecord" class="am">
                <div class="am_header">
                    <h2 class="am_title">Заявка № {{ selectedRecord.number || '—' }}</h2>
                    <p class="am_subtitle">Подана {{ formatCreatedAt(selectedRecord.created_at) }} через сайт cic.kz</p>
                </div>

                <div class="am_section">
                    <p class="am_section_title">СТАТУС ОБРАБОТКИ</p>
                    <div class="am_timeline">
                        <div v-for="step in statusSteps" :key="step.code" class="am_timeline_item">
                            <div class="am_timeline_dot" :class="{
                                'am_timeline_dot_active': selectedRecord.status?.code === step.code,
                                'am_timeline_dot_rejected': step.code === 'rejected' && selectedRecord.status?.code === 'rejected'
                            }"></div>
                            <div class="am_timeline_body">
                                <span v-if="selectedRecord.status?.code === step.code" class="am_timeline_date">
                                    {{ formatCreatedAt(selectedRecord.created_at) }}
                                </span>
                                <p class="am_timeline_status">{{ step.label }}</p>
                                <p v-if="selectedRecord.status?.code === step.code" class="am_timeline_desc">Заявка
                                    получена
                                    страховой компанией</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="am_section">
                    <p class="am_section_title">ДАННЫЕ ЗАЯВИТЕЛЯ</p>
                    <div class="am_grid">
                        <div class="am_field">
                            <span class="am_field_label">ФИО заявителя</span>
                            <span class="am_field_value">{{ selectedRecord.applicant_full_name || '—' }}</span>
                        </div>
                        <div class="am_field">
                            <span class="am_field_label">ИИН</span>
                            <span class="am_field_value">{{ selectedRecord.applicant_iin || '—' }}</span>
                        </div>
                        <div class="am_field">
                            <span class="am_field_label">Телефон</span>
                            <span class="am_field_value">{{ selectedRecord.phone || '—' }}</span>
                        </div>
                        <div class="am_field">
                            <span class="am_field_label">Email</span>
                            <span class="am_field_value">{{ selectedRecord.email || '—' }}</span>
                        </div>
                    </div>
                </div>

                <div class="am_section">
                    <p class="am_section_title">СТРАХОВОЕ СОБЫТИЕ</p>
                    <div class="am_grid">
                        <div class="am_field">
                            <span class="am_field_label">Марка / Модель</span>
                            <span class="am_field_value">{{ selectedRecord.car_model || '—' }}</span>
                        </div>
                        <div class="am_field">
                            <span class="am_field_label">ГРНЗ</span>
                            <span class="am_field_value">{{ selectedRecord.car_plate || '—' }}</span>
                        </div>
                        <div class="am_field">
                            <span class="am_field_label">Дата / Время</span>
                            <span class="am_field_value">{{ selectedRecord.event_date || selectedRecord.date || '—'
                                }}</span>
                        </div>
                        <div class="am_field">
                            <span class="am_field_label">Адрес</span>
                            <span class="am_field_value">{{ selectedRecord.address || '—' }}</span>
                        </div>
                        <div class="am_field">
                            <span class="am_field_label am_field_label_red">Вид случая</span>
                            <span class="am_field_value">{{ selectedRecord.type || '—' }}</span>
                        </div>
                        <div class="am_field">
                            <span class="am_field_label">Примерная сумма ущерба</span>
                            <span class="am_field_value">250 000 ₸</span>
                        </div>
                    </div>
                    <div class="am_field am_field_full">
                        <span class="am_field_label">Описание</span>
                        <span class="am_field_value">{{ selectedRecord.description || '—' }}</span>
                    </div>
                </div>

                <div class="am_section am_section_last">
                    <p class="am_section_title">
                        ПРИКРЕПЛЕННЫЕ ДОКУМЕНТЫ{{ selectedRecord.attachments?.length ? `
                        (${selectedRecord.attachments.length})` : '' }}
                    </p>
                    <template v-if="selectedRecord.attachments?.length">
                        <div v-for="attachment in selectedRecord.attachments" :key="attachment.id" class="am_doc">
                            <div class="am_doc_left">
                                <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
                                    <path d="M12 1H3C1.9 1 1 1.9 1 3v18c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8l-7-7z"
                                        stroke="#BFBFBF" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 1v7h7" stroke="#BFBFBF" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <span class="am_doc_name">{{ attachment.doc_label || attachment.name || 'Документ'
                                    }}</span>
                                <span class="am_doc_size">{{ formatFileSize(attachment.size) }}</span>
                            </div>
                            <div class="am_doc_actions">
                                <button class="am_doc_btn" @click="previewAttachment(attachment)">Просмотр</button>
                                <button class="am_doc_btn" @click="downloadAttachment(attachment)">Скачать</button>
                            </div>
                        </div>
                    </template>
                    <p v-else class="am_no_docs">Документы не прикреплены</p>
                </div>
            </div>
        </a-spin>
    </a-modal>
</template>

<script>
import { Tabs, Input, DatePicker, Divider, Button, Spin, Table, Select, ConfigProvider, Modal } from 'ant-design-vue'
import ruRu from 'ant-design-vue/es/locale/ru_RU'
import { SearchOutlined, CalendarOutlined, DownloadOutlined } from '@ant-design/icons-vue'
import axios from 'axios';
import { useToast } from 'vue-toastification'
import store from '@/store'
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/ru';
import 'dayjs/locale/ru';
import router from "@/router";
import ContractPaymentModal from './ContractPaymentModal.vue';
import PersonalAccountSearchForm from './PersonalAccountSearchForm.vue';
dayjs.locale('ru');
moment.locale('ru');
const toaster = useToast();

const paymentColumns = [
    {
        title: 'Номер договора',
        dataIndex: 'contract_number',
        key: 'contract_number',
        // width: '15%'
    },
    {
        title: 'Объект',
        dataIndex: 'car_info',
        key: 'car_info',
        // width: '15%',
    },
    {
        title: 'Вид страхового случая',
        dataIndex: 'type',
        key: 'type',
        // width: '10%'
    },
    {
        title: 'Адрес происшествия',
        dataIndex: 'address',
        key: 'address',
        // width: '10%'
    },
    {
        title: 'Дата обращения',
        dataIndex: 'date',
        key: 'date',
        // width: '12%'
    },
    {
        title: 'Краткое описание',
        dataIndex: 'description',
        key: 'description',
        // width: '15%'
    },
    {
        title: 'Контактный номер',
        dataIndex: 'phone',
        key: 'phone',
        // width: '15%'
    },
];

const selfColumns = [
    {
        title: 'Номер договора',
        dataIndex: 'number',
        key: 'number',
        // width: '15%'
    },
    {
        title: 'Объект',
        dataIndex: 'car_model',
        key: 'car_model',
        // width: '15%',
    },
    {
        title: 'Вид страхового случая',
        dataIndex: 'type',
        key: 'type',
        // width: '10%'
    },
    {
        title: 'Адрес происшествия',
        dataIndex: 'address',
        key: 'address',
        // width: '10%'
    },
    {
        title: 'Дата обращения',
        dataIndex: 'date',
        key: 'date',
        // width: '12%'
    },
    {
        title: 'Краткое описание',
        dataIndex: 'description',
        key: 'description',
        // width: '15%'
    },
    {
        title: 'Документы',
        dataIndex: 'description',
        key: 'description',
        // width: '15%'
    },
    {
        title: 'Статус',
        dataIndex: 'status',
        key: 'status',
        // width: '15%',
        customRender: ({ record }) => record.status?.label || '—',
    },
    {
        title: 'Контактный номер',
        dataIndex: 'phone',
        key: 'phone',
        // width: '15%'
    },
];

export default {
    emits: ['total-updated'],
    props: {
        selectedCompanyId: {
            type: Number,
            default: null
        },
        appealsScope: {
            type: String,
            default: "others"
        }
    },
    components: {
        AInput: Input,
        ADatePicker: DatePicker,
        ADivider: Divider,
        AButton: Button,
        ASpin: Spin,
        ATabPane: Tabs.TabPane,
        ATabs: Tabs,
        ATable: Table,
        AModal: Modal,
        SearchOutlined,
        CalendarOutlined,
        DownloadOutlined,
        ASelect: Select,
        AConfigProvider: ConfigProvider,
        ContractPaymentModal,
        PersonalAccountSearchForm,
    },
    data() {
        return {
            ruRu,
            user: store.getters['auth/getUser'],
            activeKey: 'contracts',
            searchData: {
                search: null,
                type_id: 1,
                product: null,
                start_date: null,
                end_date: null,
                payment_status: null
            },
            paymentColumns,
            selfColumns,
            paymentsList: [],
            road_accidents: [],
            isModalInfo: false,
            isLoadingModal: false,
            currentActiveRecord: -1,
            selectedRecord: null,
            statusSteps: [
                { code: 'sent', label: 'Направлен на рассмотрение' },
                { code: 'review', label: 'Рассматривается' },
                { code: 'accepted', label: 'Принят в работу' },
                { code: 'rejected', label: 'Отказано' },
            ],
            isLoadingPaymentList: false,
            productTypeList: [],
            contractTypeList: [],
            isLoadingContractsObjectsList: false,
            isOpenContractModal: false,
            openedContract: null,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
            },
        }
    },
    mounted() {
        if (localStorage.getItem("auth_token")) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("auth_token")}`
        }
        this.isLoadingPaymentList = true
        if (this.selectedCompanyId) {
            this.pagination.current = 1;
            this.pagination.pageSize = 10;
            this.getProductList()
        }
    },
    methods: {
        onChangePagination(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getRoadAccidents({ ...this.searchData, start_date: this.searchData.start_date ? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY') : null });
        },
        customRow(record) {
            return {
                onClick: () => {
                    this.openRequestModal(record);
                },
            }
        },
        onCancel() {
            this.isModalInfo = false;
            const htmlEl = document.querySelector("html")
            htmlEl.style.overflow = '';
            this.isLoadingModal = false;
            this.currentActiveRecord = -1;
            this.selectedRecord = null;
        },
        async openRequestModal(record) {
            this.isModalInfo = true;
            const htmlEl = document.querySelector("html")
            htmlEl.style.overflow = 'hidden';
            this.currentActiveRecord = record.id;
            this.selectedRecord = record;
            this.isLoadingModal = true;
            try {
                const res = await axios.get(`/V1/requests/${record.id}?company_id=${this.selectedCompanyId}`);
                this.selectedRecord = res.data.data.request;
            } catch (error) {
                let message = axios.isAxiosError(error) && error.response
                    ? error.response.data.message
                    : String(error);
                toaster.error(message || 'Ошибка загрузки данных заявки', { position: 'top-right' });
            } finally {
                this.isLoadingModal = false;
            }
        },
        async fetchAttachmentBlob(attachment) {
            const res = await axios.get(attachment.download_url, { responseType: 'blob' });
            return new Blob([res.data], { type: attachment.mime_type || 'application/octet-stream' });
        },
        async downloadAttachment(attachment) {
            try {
                const blob = await this.fetchAttachmentBlob(attachment);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = attachment.name || 'document';
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch {
                toaster.error('Ошибка скачивания файла', { position: 'top-right' });
            }
        },
        async previewAttachment(attachment) {
            try {
                const blob = await this.fetchAttachmentBlob(attachment);
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
            } catch {
                toaster.error('Ошибка открытия файла', { position: 'top-right' });
            }
        },
        formatFileSize(bytes) {
            if (!bytes) return '';
            if (bytes < 1024) return bytes + ' B';
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
            return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
        },
        formatCreatedAt(createdAt) {
            if (!createdAt) return '—';
            return dayjs(createdAt).format('DD.MM.YYYY, HH:mm');
        },
        async getRoadAccidents(data) {
            const { current, pageSize } = this.pagination;

            switch (this.appealsScope) {
                case "others": {
                    await axios.get(`/V1/road-accidents?company_id=${this.selectedCompanyId}&page=${current}&per_page=${pageSize}`, { params: data }).then(res => {
                        this.road_accidents = res.data.data.road_accidents.map(item => {
                            return {
                                ...item,
                                // product: item.contract.product,
                                // number: item.contract.number,
                                // plate_number: item.object.plate_number,
                                // vin: item.object.vin,
                            }
                        });
                        this.pagination.total = res.data.meta.total;
                        this.$emit('total-updated', res.data.meta.total);
                        this.isLoadingPaymentList = false
                    }).catch(error => {
                        let message;
                        if (axios.isAxiosError(error) && error.response) {
                            message = error.response.data.message;
                        } else {
                            message = String(error);
                        }
                        if (message.length === 0) {
                            message = 'Произошла ошибка при загрузке данных';
                        }
                        toaster.error(message, {
                            position: "top-right"
                        })
                    })

                    break;
                }
                case "my": {
                    await axios.get(`/V1/requests?company_id=${this.selectedCompanyId}&page=${current}&per_page=${pageSize}`, { params: data }).then(res => {
                        // console.log(res.data.data);
                        this.road_accidents = res.data.data.items.map(item => {
                            return {
                                ...item,
                                // product: item.contract.product,
                                // number: item.contract.number,
                                // plate_number: item.object.plate_number,
                                // vin: item.object.vin,
                            }
                        });

                        this.pagination.total = res.data.meta.total;
                        this.$emit('total-updated', res.data.meta.total);
                        this.isLoadingPaymentList = false
                    }).catch(error => {
                        let message;
                        if (axios.isAxiosError(error) && error.response) {
                            message = error.response.data.message;
                        } else {
                            message = String(error);
                        }
                        if (message.length === 0) {
                            message = 'Произошла ошибка при загрузке данных';
                        }
                        toaster.error(message, {
                            position: "top-right"
                        })
                    })

                    break;
                }
            }
        },
        async getProductList() {
            this.isLoadingProductList = true
            this.isLoadingPaymentList = true
            await axios.get(`/V1/my-contracts/type-products?company_id=${this.selectedCompanyId}`).then(res => {
                this.productTypeList = res.data.data.types.map(item => {
                    return {
                        label: item.label,
                        value: item.id,
                        children: item.products.map(product => {
                            return {
                                label: product,
                                value: product,
                            }
                        })
                    }
                });
                this.contractTypeList = res.data.data.types.filter(item => item.id === 1)[0].products.map(item => {
                    return {
                        label: item,
                        value: item
                    }
                })
                if (this.contractTypeList.length === 1) {
                    this.searchData.product = this.contractTypeList[0].value
                }
                this.getRoadAccidents({ ...this.searchData, start_date: this.searchData.start_date ? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY') : null })
            }).catch(error => {
                let message;
                if (axios.isAxiosError(error) && error.response) {
                    message = error.response.data.message;
                } else {
                    message = String(error);
                }
                if (message.length === 0) {
                    message = 'Произошла ошибка при загрузке данных';
                }
                toaster.error(message, {
                    position: "top-right"
                })

                if (error.status === 401) {
                    store.dispatch('auth/logoutTokenUnactive')
                    router.push('/')
                }

            })
        },
        onChangeContractNum(e) {
            this.searchData.search = e.target.value
        },
        onChangeProductType(e) {
            this.searchData.product_type = e
        },
        onChangeContractType(e) {
            this.searchData.product = e
        },
        onChangeStartDate(e) {
            this.searchData.start_date = e
        },
        onChangeEndDate(e) {
            this.searchData.end_date = e
        },
        async searchPayments() {
            try {
                this.isLoadingPaymentList = true
                this.pagination.current = 1;
                this.pagination.pageSize = 10;
                await this.getRoadAccidents({ ...this.searchData, start_date: this.searchData.start_date ? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY') : null })
            } catch (error) {
                let message;
                if (axios.isAxiosError(error) && error.response) {
                    message = error.response.data.message;
                } else {
                    message = String(error);
                }
                if (message.length === 0) {
                    message = 'Произошла ошибка при загрузке данных';
                }
                toaster.error(message, {
                    position: "top-right"
                })
            } finally {
                this.isLoadingPaymentList = false
            }
        },
        async downloadFile(record) {
            try {
                const response = await axios.get(record.file_path, {
                    responseType: 'blob',
                })
                const blob = new Blob([response.data])
                const downloadUrl = window.URL.createObjectURL(blob)

                const link = document.createElement('a')
                link.href = downloadUrl
                link.download = `${record.number}.pdf`
                document.body.appendChild(link)
                link.click()
                link.remove()

                window.URL.revokeObjectURL(downloadUrl)
            } catch (error) {
                let message;
                if (axios.isAxiosError(error) && error.response) {
                    message = error.response.data.message;
                } else {
                    message = String(error);
                }
                if (message.length === 0) {
                    message = 'Договор не найден';
                }
                toaster.error(message, {
                    position: "top-right"
                })
            }
        },
        openContractModal(record) {
            this.isOpenContractModal = true
            this.openedContract = record
        },
        requestExcuse() {
            this.$router.push(`/excuse?companyId=${this.selectedCompanyId}`);
        },
        async getAllReports() {
            try {
                const startDate = this.searchData.start_date?.format("YYYY-MM-DD") ?? "";
                const endDate = this.searchData.end_date?.format("YYYY-MM-DD") ?? "";
                const response = await axios.get(`/V1/combined-export?company_id=${this.selectedCompanyId}&type_id=${1}&start_date=${startDate}&end_date=${endDate}`, { responseType: "blob" })
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const url = window.URL.createObjectURL(blob);
                const disposition = response.headers['content-disposition'];
                let filename = 'reports.xlsx';
                if (disposition && disposition.includes('filename=')) {
                    const filenameRegex = /filename\*=utf-8''([^;]+)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = decodeURIComponent(matches[1]);
                    } else {
                        // Если нет filename*=, пробуем обычный filename=
                        const filenameSimpleRegex = /filename="?([^"]+)"?/;
                        const simpleMatches = filenameSimpleRegex.exec(disposition);
                        if (simpleMatches != null && simpleMatches[1]) {
                            filename = simpleMatches[1];
                        }
                    }
                }
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); // Название файла
                document.body.appendChild(link);
                link.click();

                link.remove(); // Очистка
                window.URL.revokeObjectURL(url)

            } catch (error) {
                let message;
                if (axios.isAxiosError(error) && error.response) {
                    message = error.response.data.message;
                } else {
                    message = String(error);
                }
                if (message.length === 0) {
                    message = 'Договор не найден';
                }
                toaster.error(message, {
                    position: "top-right"
                })
            }
        },
        async exportContracts() {
            try {
                const response = await axios.post(`/V1/road-accidents/export?company_id=${this.selectedCompanyId}`, { ids: this.road_accidents.map(contract => contract.id), contract_type: this.searchData.type_id }, { responseType: "blob" })
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const url = window.URL.createObjectURL(blob);
                const disposition = response.headers['content-disposition'];
                let filename = 'contracts.xlsx';
                if (disposition && disposition.includes('filename=')) {
                    const filenameRegex = /filename\*=utf-8''([^;]+)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = decodeURIComponent(matches[1]);
                    } else {
                        // Если нет filename*=, пробуем обычный filename=
                        const filenameSimpleRegex = /filename="?([^"]+)"?/;
                        const simpleMatches = filenameSimpleRegex.exec(disposition);
                        if (simpleMatches != null && simpleMatches[1]) {
                            filename = simpleMatches[1];
                        }
                    }
                }
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); // Название файла
                document.body.appendChild(link);
                link.click();

                link.remove(); // Очистка
                window.URL.revokeObjectURL(url)

            } catch (error) {
                let message;
                if (axios.isAxiosError(error) && error.response) {
                    message = error.response.data.message;
                } else {
                    message = String(error);
                }
                if (message.length === 0) {
                    message = 'Договор не найден';
                }
                toaster.error(message, {
                    position: "top-right"
                })
            }
        },
    },
    watch: {
        selectedCompanyId(newVal) {
            if (newVal) {
                this.pagination.page = 1;
                this.pagination.current = 1;
                this.getProductList()
            }
        },
        appealsScope(newVal) {
            this.pagination = {
                current: 1,
                pageSize: 10,
                total: 0
            };

            this.getRoadAccidents({ ...this.searchData, start_date: this.searchData.start_date ? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY') : null })
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin fontStyle ($family,$style,$weight, $size, $lheight, $color) {
	font-family: $family;
	font-style: normal;
	font-weight: $weight;
	font-size: $size;
	line-height: $lheight;
	color: $color;
}
@mixin mobile {
	@media(min-width: 320px) and (max-width: 425px) {
		@content;
	}
}
@mixin tablet {
	@media(min-width: 425px) and (max-width: 767px) {
		@content;
	}
}
@mixin tablet-1024 {
	@media(min-width: 767px) and (max-width: 1024px) {
		@content;
	}
}
@mixin desktop {
	@media(min-width: 1024px) and (max-width: 1440px) {
		@content;
	}
}
@mixin desktop-max {
	@media(min-width: 1620px) and (max-width: 2560px) {
		@content;
	}
}
.col_p{
	margin-bottom: 0;
}

.ant-tooltip-inner {
	width: 320px;
}

.personal_account{
	padding: 30px 0;
	&_tabel{
		contain: layout
	}
	&_title{
		@include fontStyle(Roboto, normal, 500, 24px, 31px, #373737);
		text-align: center;
	}
	&_desc{
		@include fontStyle(Roboto, normal, 400, 22px, 31px, #909090);
		text-align: center;
		span{
			@include fontStyle(Roboto, normal, 400, 22px, 31px, #373737);
		}
	}
	&_info{
		@include fontStyle(Roboto, normal, 400, 24px, 31px, #373737);
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		row-gap: 15px;

		@media (max-width: 1024px) {
			flex-direction: column;
			align-items: flex-start;
		}

		&_left{
			width: 30%;
			@include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);
			&_select{
				width: 100%;
				height: 50px;
			}

			@media (max-width: 1024px) {
				width: 100%;
			}
		}
		&_right{
			display: flex;
			gap: 10px;
			flex-wrap: wrap;

			@media (max-width: 1024px) {
				width: 100%;
			}

			button{
				@include fontStyle(Roboto, normal, 400, 16px, 31px, #373737);
				padding: 4px 20px;
				height: 55px;
				display: flex;
				align-items: center;
				img{
					width: 24px;
					margin-right: 10px;
				}

				@media (max-width: 767px) {
					flex: 1 1 100%;
					height: auto;
					min-height: 44px;
					padding: 8px 14px;
					font-size: 14px;
					white-space: normal;
					text-align: left;
				}
			}
		}
	}
}
::v-deep(.ant-table){
	contain: layout;
}
::v-deep(.personal_account_info_left){
	.ant-select-selector{
		height: 50px;
		input{
			height: 50px;
		}
		.ant-select-selection-placeholder{
			height: 50px;
			display: flex;
			align-items: center;
		}
	}
}
::v-deep(.personal_account_table){
	.ant-pagination{
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: flex-end;
		gap: 8px;
		row-gap: 10px;

		@media (max-width: 575px) {
			justify-content: center;
		}
	}
	.ant-pagination-options{
		margin-left: 0;

		@media (max-width: 575px) {
			order: 10;
			width: 100%;
			display: flex;
			justify-content: center;
		}
	}
}
.product_name_col{
	display: flex;
	gap: 10px;
	align-items: center;
}
.product_name_line{
	height: 38px;
	width: 5px;
	background: #007BFF;
	border-radius: 3px;
	&_warning{
		background: #FF8E0D;
	}
	&_error{
		background: #C00202;
	}
}
.download_btn, .open_btn{
	background-color: #fff;
	padding: 4px 8px;
	border: 2px solid #F5F5F5;
	border-radius: 4px;
	cursor: pointer;
}
.download_btn:hover, .open_btn:hover{
	color: #007BFF !important;
	text-decoration: underline !important;
	transition: .3s;
}
.download_btn{
	span{
		color: #007BFF;
		font-size: 18px;
	}
}
::v-deep(.ant-tabs){
	.ant-tabs-nav-list{
		background: #F4F4F8 !important;
		border-radius: 8px;
		width: 100%;
		justify-content: space-between;
		padding: 15px 25px;
		.ant-tabs-tab-active{
			background: white !important;
		}
		.ant-tabs-tab{
			display: flex;
			justify-content: center;
			width: 30%;
			border: none;
			background: none;
			div{
				font-size: 22px;
				color: #373737;
				border-radius: 8px;
				padding: 7px 0;
			}
		}
	}
	.ant-tabs-content-holder{
		margin-top: 20px;
		.ant-tabs-tabpane{
			background: #F4F4F8 !important;
			border-radius: 8px;
		}
	}
}
.card-container p {
	margin: 0;
}
.card-container > .ant-tabs-card .ant-tabs-content {
	height: 120px;
	margin-top: -16px;
}
.card-container > .ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane {
	padding: 16px;
	background: #fff;
}
.card-container > .ant-tabs-card > .ant-tabs-nav::before {
	display: none;
}
.card-container > .ant-tabs-card .ant-tabs-tab,
[data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab {
	background: transparent;
	border-color: transparent;
}
.card-container > .ant-tabs-card .ant-tabs-tab-active,
[data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab-active {
	background: #fff;
	border-color: #fff;
}
#components-tabs-demo-card-top .code-box-demo {
	padding: 24px;
	overflow: hidden;
	background: #f5f5f5;
}
::v-deep(.contract_action-row-warning){
	background: rgba(255, 142, 13, 0.102);
	&:hover{
		td{
			background: #FF8E0D1A !important;
		}
	}
}
::v-deep(.contract_action-row-error){
	background: #C002021A;
	&:hover{
		td{
			background: #C002021A !important;
		}
	}
}
.tooltip-content{
	padding: 10px 0;
	display: flex;
	align-items: center;
	gap: 10px;
	p{
		margin-bottom: 0;
	}
	img{
		width: 24px;
	}
	&_text {
		p, span {
			color: #663C00;
		}
		p {
			font-weight: bold;
		}
		&_error{
			color: #fff;
		}
	}
}
.contract_action{
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	&_warning{
		width: 40px;
		height: 40px;
		background: #FFF3E7;
		color: #fff;
		padding: 4px 8px;
		border-radius: 4px;
		font-size: 18px;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 100%;
		}
	}
	&_error{
		width: 40px;
		height: 40px;
		color: #fff;
		padding: 4px 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		font-size: 18px;
	}
	&_tooltip_warning{
		width: 30px;
		height: 30px;
		background: #fff;
		padding: 4px 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		font-size: 18px;
	}
	&_tooltip_error{
		width: 30px;
		height: 30px;
		background: #fff;
		padding: 4px 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		font-size: 18px;
		color: #FF0000;
	}
}
::v-deep(.ant-btn-default) {
	transition: .3s all;
	&:hover {
		background: #0059B9;
		color: #fff;
		img {
			filter: brightness(0) invert(1);
		}
	}
}
</style>
